import createAsyncAction from 'utilities/create-async-action';
import * as Sentry from '@sentry/react';

/**
 * Create the action
 */

const { 
    thunk, 
    request, 
    success, 
    error 
} = createAsyncAction({
    name: 'RETRIEVE_AUTHENTICATED_USER',
    asyncAction: retrieveAuthenticatedUser,
    onSuccess: setSentry
});

function retrieveAuthenticatedUser(fetch) {
    return fetch.get('auth/user');
}

function setSentry(data) {
    Sentry.setUser({ 
        email: data.email,
        id: data.id,
        username: data.first_name + ' ' + data.last_name,
        organisationName: data.organisation? data.organisation.name : 'unknown'
    });
}

/**
 * Export the components
 */

export default thunk;
export { request, success, error };
